module.exports = __webpack_public_path__ + "img/Gaming Esport Logo Vol. 06-01.jpg";